
/**
 * Set Icon to left or right using flex ORDER 1 or -1
 */
 export enum IconPlacement {
   Left = 'left-icon',
   Right = 'right-icon'
 }
 